import { LazyIssueApp } from '@jira/issue__lazy-app/src/LazyIssueApp.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdContent } from '@jira/navigation-apps__constants/src/SidebarIdContent.tsx';
import { getRapidboardResources } from '@jira/router-resources__classic-projects/src/getRapidboardResources.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { rapidboardReportRoute } from '@jira/router-routes__classic-projects-routes/src/rapidboardReportRoute.tsx';
import {
	RapidBoardSpaPage,
	LazyRapidBoard,
	LazyRapidBoardApps,
} from '@jira/router-routes__user-board-entries/src/ui/async.tsx';
import { ClassicReportSkeleton } from '@jira/platform__skeletons/src/ui/classic-report/ClassicReportSkeleton.tsx';
import { genericProjectLayout } from '@jira/platform__layouts-generic-project-layout/src/index.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { getIssueViewResources } from '@jira/router-resources__issue-view/src/getIssueViewResources.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { AGGRESSIVE_EARLY_ASSET_STRATEGY } from '@jira/platform__common-constants/src/ssr-early-assets.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { getReportsCommonResource } from './common/ui/resources/reports/index.tsx';
import {
	GSNReportPageProjectEntrypoint,
	reportPageProjectEntrypoint,
} from './ui/reportPageEntrypoint.tsx';

export const rapidboardReportRouteEntry: Route = createEntry(rapidboardReportRoute, () => ({
	group: 'classic-software',
	// eslint-disable-next-line no-restricted-syntax
	component: RapidBoardSpaPage,
	skeleton: ClassicReportSkeleton,
	layout: genericProjectLayout,
	navigation: {
		menuId: MenuIdProjects,
		sidebarId: SidebarIdContent,
	},
	resources: [
		...getNavigationResources({ isUsingSidebarEntrypoint: true }),
		...getIssueViewResources(),
		// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
		// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
		incidentExperimentTraitResource,
		// eslint-disable-next-line jira/router/no-project-context-resource
		projectContextResource,
		forgeProjectModuleResource,
		staticProjectSidebarNavigationResource,
		staticProjectSidebarConnectAddonsNavigationResource,
		// end of resources expanded from getNavigationSidebarProjectResource
		...getRapidboardResources(),
		...getReportsCommonResource(),
	],
	afterPaint: [LazyIssueApp],
	forPaint: [LazyAtlassianNavigation, LazyRapidBoard, LazyRapidBoardApps],
	earlyAssets: AGGRESSIVE_EARLY_ASSET_STRATEGY,
	ufoName: 'classic-report',
	entryPoint: () =>
		fg('navx-global-side-nav') ? GSNReportPageProjectEntrypoint : reportPageProjectEntrypoint,
	supportsPreviewPanel: true,
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
